import axios from "axios";
import React, { createContext } from "react";
import { baseURL } from "../Config/Config";


export const VideoContext = createContext()

export const VideoProvider = ({ children }) => {
    const [videoData, setVideoData] = React.useState()
    React.useEffect(() => {
        axios.get(`${baseURL}video/category-video-list/`).then((response) => {
            setVideoData(response.data)
        }).catch((err) => {
            console.log(err)
        })
    }, [])
    return (
        <VideoContext.Provider value={[videoData, setVideoData]}>
            {children}
        </VideoContext.Provider>
    )
}

